import { ReactNode } from "react";

import {
  ColumnDef,
  ColumnPinningState,
  SortingState
} from "@/src/components/organisms/AdminDataTable/reactTable";

export type DensityMode = "compact" | "standard" | "comfortable";

export const DENSITY_ROW_HEIGHT: Record<DensityMode, number> = {
  compact: 28,
  standard: 39,
  comfortable: 52
};

export interface AdminDataTableProps<TData extends object> {
  data: TData[];
  columns: ColumnDef<TData, unknown>[];
  getRowId: (row: TData, index: number) => string;
  initialSorting?: SortingState;
  initialColumnPinning?: ColumnPinningState;
  initialColumnVisibility?: Record<string, boolean>;
  height: number | string;
  /**
   * Optional max width for the table container. Defaults to `100%`.
   * Use e.g. `"fit-content"` to shrink the container to the combined column width
   * so the table ends right after the last column.
   */
  maxWidth?: number | string;
  densityStorageKey?: string;
  emptyMessage?: string;
  loadingMessage?: string;
  isLoading?: boolean;
  /** Whether more data is being fetched in the background (shown in the status bar). */
  isLoadingMore?: boolean;
  loadMoreSlot?: ReactNode;
  exportFileName?: string;
  /**
   * Whether the CSV export action should be rendered in the toolbar.
   * Defaults to `true`.
   */
  enableCsvExport?: boolean;
  toolbarTitle?: string;
  /** Rendered immediately before the global search field (e.g. primary actions left of “Etsi”). */
  toolbarSearchExtras?: ReactNode;
  toolbarExtras?: ReactNode;
  /**
   * Row id (matching `getRowId`) to scroll to and briefly highlight, e.g.
   * when navigating in from outside the table. Clears any active column/
   * global filters so the row can never be hidden by stale filter state.
   */
  scrollToRowId?: string;
  /** Called once the target row has actually been scrolled to. */
  onScrolledToRow?: () => void;
}
